import { render, staticRenderFns } from "./MyCompanyTaxTypesEdit.vue?vue&type=template&id=3c01f1a6&"
import script from "./MyCompanyTaxTypesEdit.vue?vue&type=script&lang=js&"
export * from "./MyCompanyTaxTypesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports